import { Share2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { copyToClipboard } from "~/common/functions";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui";

interface ShareButtonProps {
  className?: string;
}

/**
 * Copies the current URL to the clipboard. Pairs with the URL-synced view state
 * so a shared link restores the exact filters, view, and pan/zoom.
 */
export function ShareButton({ className }: ShareButtonProps) {
  const { t } = useTranslation();

  const onShare = async () => {
    try {
      await copyToClipboard(window.location.href);
      toast.success(t("feature.common.urlCopied"));
    } catch {
      toast.error(t("feature.common.copyToClipboardFailed"));
    }
  };

  const label = t("feature.common.share", { defaultValue: "Share" });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="outline" size="icon" onClick={onShare} aria-label={label} className={className}>
          <Share2 />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
